import React from 'react';
import image from '../../../images/candevice.png';
import { useTranslation } from 'react-i18next';

const PairDeviceCard = ({ setAddDeviceModal }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        width: '90%',
        padding: '24px',
        flexDirection: 'column',
        gap: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden',
        margin: '0 auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          minWidth: '0',
          justifyContent: 'space-between',
          alignItems: 'center',
          alignSelf: 'stretch',
          flexShrink: '0',
          flexWrap: 'nowrap',
          position: 'relative',
        }}
      >
        <span
          style={{
            height: '28px',
            flexShrink: '0',
            flexBasis: 'auto',
            fontFamily: 'Roboto, var(--default-font-family)',
            fontSize: window.innerWidth <= 768 ? '16px' : '20px',
            fontWeight: '500',
            lineHeight: window.innerWidth <= 768 ? '24px' : '28px',
            color: '#1d1d1f',
            position: 'relative',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            zIndex: '1',
          }}
        >
          {t('canGo')}
        </span>
        <div
          style={{
            display: 'flex',
            width: '127px',
            gap: '8px',
            alignItems: 'center',
            alignSelf: 'stretch',
            flexShrink: '0',
            flexWrap: 'nowrap',
            position: 'relative',
            zIndex: '2',
          }}
        >
          <button
            style={{
              display: 'flex',
              width: '87px',
              height: '32px',
              padding: '7.996px 12px 7.996px 12px',
              gap: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: '0',
              flexWrap: 'nowrap',
              backgroundColor: '#00796b',
              borderRadius: '100px',
              border: 'none',
              position: 'relative',
              zIndex: '3',
              cursor: 'pointer',
            }}
            onClick={setAddDeviceModal}
          >
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '22px',
                color: '#ffffff',
                position: 'relative',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '4',
              }}
            >
              {t('connect')}
            </span>
          </button>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <div>
          <img
            style={{
              maxWidth: '300px',
              width: '100%',
              height: 'auto',
              maxHeight: '500px',
              objectFit: 'contain',
              position: 'relative',
              zIndex: '17',
            }}
            src={image}
            alt="can-device"
          />
        </div>
        <div
          style={{
            alignSelf: window.innerWidth <= 768 ? 'stretch' : 'center',
            width: window.innerWidth <= 768 ? '100%' : 'auto',
            marginLeft: window.innerWidth <= 768 ? '0' : '50px',
          }}
        >
          <div
            style={{
              padding: '20px',
              background: '#F5F5F7',
              borderRadius: '20px',
              maxWidth: '400px',
              margin: '0 auto',
            }}
          >
            <h4
              style={{
                fontSize: window.innerWidth <= 768 ? '18px' : '20px',
                margin: '0 0 10px 0',
              }}
            >
              {t('canGoSmartCane')}
            </h4>
            <span
              style={{
                fontSize: window.innerWidth <= 768 ? '11px' : '12px',
                display: 'block',
                marginBottom: '8px',
              }}
            >
              {t('smartCaneTagline')}
            </span>
            <button
              style={{
                background: '#26796b',
                color: '#fff',
                width: '100%',
                paddingBlock: '8px',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
              onClick={() => window.open('https://can.co/', '_blank')}
            >
              {t('getYoursNow')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PairDeviceCard;
